import React from 'react';
import TextInput from '../../components/form/TextInput';

export default class MedidasForm extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      ativo: false
    };
    this.openMedida = this.openMedida.bind(this);
  }

  openMedida(e){
    e.preventDefault();
    this.setState({
      ativo: !this.state.ativo
    });
  }

  render(){
    const data = this.props.data;
    const str = this.props.strings;
    return(
      <div className={`${this.state.ativo ? 'ativo' : ''} box-medida-cliente`}>
        <div >
          <a href='#' onClick={this.openMedida} className='bt-open-medida'>
            <span>{str.dataCriacao}</span><span className="data-criacao-medida">{data.data}</span>
            <i className="fas fa-chevron-down"></i>
        </a>
        </div>
        <div className='box-medida'>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.peso} name="peso" title={str.fieldPeso} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.altura} name="altura" title={str.fieldAltura} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.gordura_corporal} name="gordura_corporal" title={str.fieldGordCorp} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.biceps_direito} name="biceps_direito" title={str.fieldBicepsDir} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.biceps_esquerdo} name="biceps_esquerdo" title={str.fieldBicepsEsq} placeholder=''></TextInput>
          </div>

          <div className="pure-u-1-5">
            <TextInput readOnly value={data.antebraco_esquerdo} name="antebraco_esquerdo" title={str.fieldAntebracoEsq} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.antebraco_direito} name="antebraco_direito" title={str.fieldAntebracoDir} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.coxa_direita} name="coxa_direita" title={str.fieldCoxaDir} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.coxa_esquerda} name="coxa_esquerda" title={str.fieldCxaEsq} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.panturrilha_esquerda} name="panturrilha_esquerda" title={str.fieldPantEsq} placeholder=''></TextInput>
          </div>

          <div className="pure-u-1-5">
            <TextInput readOnly value={data.panturrilha_direita} name="panturrilha_direita" title={str.fieldPantDir} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.torax} name="torax" title={str.fieldTorax} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.cintura} name="cintura" title={str.fieldCintura} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.abdomen} name="abdomen" title={str.fieldAbdomen} placeholder=''></TextInput>
          </div>
          <div className="pure-u-1-5">
            <TextInput readOnly value={data.quadril} name="quadril" title={str.fieldQuadril} placeholder=''></TextInput>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/clientes/MedidasForm.js